import { Component, Mixins } from 'vue-property-decorator';
import Layout from '@/components/layouts/main.vue';
import PageTitle from '@/components/ui/page-title/pageTitle.vue';
import BoxHeader from '@/components/ui/box-header/boxHeader.vue';
import { getPspDepositOrderStatus, getPspDepositOrderStatusList } from '@/constants/psp-deposit-order-status.constants';
import CustomDatepickerRange from '@/components/ui/inputs/custom-datepicker-range/custom-datepicker-range.vue';
import PspDepositOrdersGrid from '@/components/features/grids/psp-deposit-orders-grid/psp-deposit-orders-grid.vue';
import FilterMixin from '@/mixins/filter.mixin';
import AutocompleteInput from '@/components/ui/inputs/autocomplete-input/autocompleteInput.vue';
import { Action, Getter, Mutation } from 'vuex-class';
import { PDOStatusSummaryRequest } from '@/types/request/psp-deposit-order-request.types';
import { PdoStatusSummaryType } from '@/types/api/psp-deposit-order/pdo-status-summary.type';
import { prepareFilterDate } from '@/helpers/filter.helper';
import Box from '@/components/ui/box/box.vue';
import { appConfig } from '@/app.config';
import { MODAL_CONFIG } from '@/helpers/app.helper';
import StatusSummaryChartModal
  from '@/components/features/modals/status-summary-chart-modal/status-summary-chart-modal.vue';
import StatusSummaryTotalChart from '@/components/ui/charts/status-summary-total-chart/status-summary-total-chart.vue';
import { PdoStatusSummaryGroupType } from '@/types/api/psp-deposit-order/pdo-status-summary-group.type';
import StatusSummaryGroupTotalChart from '@/components/ui/charts/status-summary-group-total-chart/status-summary-group-total-chart.vue';
import ChartsPicker from '@/components/ui/charts-picker/charts-picker.vue';
import ChartsBox from '@/components/ui/charts-box/charts-box.vue';
import { DateTime } from 'luxon';
import { DATE_FILTER_FORMAT, DATEPICKER_FORMAT } from '@/helpers/date.helper';
import { PdoEndpointSummaryType } from '@/types/api/psp-deposit-order/pdo-endpoint-summary.type';
import { PdoPartnerSummaryType } from '@/types/api/psp-deposit-order/pdo-partner-summary.type';
import SummaryChartModal from '@/components/features/modals/summary-chart-modal/summary-chart-modal.vue';
import SummaryTotalChart from '@/components/ui/charts/summary-total-chart/summary-total-chart.vue';

const title = 'pspDepositOrders.title';

@Component({
  name: 'PspDepositOrders',
  page: {
    title
  },
  components: {
    Layout,
    PageTitle,
    BoxHeader,
    CustomDatepickerRange,
    PspDepositOrdersGrid,
    AutocompleteInput,
    Box,
    StatusSummaryTotalChart,
    StatusSummaryGroupTotalChart,
    ChartsPicker,
    ChartsBox,
    SummaryTotalChart,
  },
})
export default class PspDepositOrders extends Mixins(FilterMixin) {
  title = title;
  filter: any = this.initFilter();
  filterPrefix: string | null = null;
  filterDateDiapason: string[] = ['createdAt'];
  saveFilter = true;

  @Action('getPdoStatusSummary', { namespace: 'pspDepositOrders' })
  getPdoStatusSummary!: (params?: PDOStatusSummaryRequest) => Promise<PdoStatusSummaryType>;

  @Mutation('setPdoStatusSummary', { namespace: 'pspDepositOrders' })
  setPdoStatusSummary!: (params: PdoStatusSummaryType | null) => void;

  @Getter('getPdoStatusSummary', { namespace: 'pspDepositOrders' })
  pdoStatusSummary!: PdoStatusSummaryType;

  @Action('getPdoEndpointSummary', { namespace: 'pspDepositOrders' })
  getPdoEndpointSummary!: (params?: PDOStatusSummaryRequest) => Promise<PdoEndpointSummaryType>;

  @Mutation('setPdoEndpointSummary', { namespace: 'pspDepositOrders' })
  setPdoEndpointSummary!: (params: PdoEndpointSummaryType | null) => void;

  @Getter('getPdoEndpointSummary', { namespace: 'pspDepositOrders' })
  pdoEndpointSummary!: PdoEndpointSummaryType;

  @Action('getPdoPartnerSummary', { namespace: 'pspDepositOrders' })
  getPdoPartnerSummary!: (params?: PDOStatusSummaryRequest) => Promise<PdoPartnerSummaryType>;

  @Mutation('setPdoPartnerSummary', { namespace: 'pspDepositOrders' })
  setPdoPartnerSummary!: (params: PdoPartnerSummaryType | null) => void;

  @Getter('getPdoPartnerSummary', { namespace: 'pspDepositOrders' })
  pdoPartnerSummary!: PdoPartnerSummaryType;

  @Action('getPdoStatusSummaryGroup', { namespace: 'pspDepositOrders' })
  getPdoStatusSummaryGroup!: (params?: PDOStatusSummaryRequest) => Promise<PdoStatusSummaryGroupType>;

  @Mutation('setPdoStatusSummaryGroup', { namespace: 'pspDepositOrders' })
  setPdoStatusSummaryGroup!: (params: PdoStatusSummaryGroupType | null) => void;

  @Getter('getPdoStatusSummaryGroup', { namespace: 'pspDepositOrders' })
  pdoStatusSummaryGroup!: PdoStatusSummaryGroupType;

  created() {
    if (this.getDateRangeFilter('createdAt') && this.getDateRangeFilter('createdAt', false)) {
      // this.getPdoStatusSummary(this.getPdoStatusSummaryFilter());
      // this.getPdoEndpointSummary(this.getPdoStatusSummaryFilter());
      // this.getPdoPartnerSummary(this.getPdoStatusSummaryFilter());
      // this.getPdoStatusSummaryGroup(this.getPdoStatusSummaryFilter());
    }
  }

  beforeDestroy() {
    this.setPdoStatusSummary(null);
    this.setPdoEndpointSummary(null);
    this.setPdoPartnerSummary(null);
    this.setPdoStatusSummaryGroup(null);
  }

  setPdoStatusSummaryRequest(filter = {}) {
    return this.getPdoStatusSummary(this.getPdoStatusSummaryFilter(filter));
  }

  getPdoEndpointSummaryRequest(filter = {}) {
    return this.getPdoEndpointSummary(this.getPdoStatusSummaryFilter(filter));
  }

  getPdoPartnerSummaryRequest(filter = {}) {
    return this.getPdoPartnerSummary(this.getPdoStatusSummaryFilter(filter));
  }

  setPdoStatusSummaryGroupRequest(filter = {}) {
    return this.getPdoStatusSummaryGroup(this.getPdoStatusSummaryFilter(filter));
  }

  getPdoStatusSummaryFilter(filter = {}): any {
    const createdAtStart = this.getDateRangeFilter('createdAt');
    const createdAtEnd = this.getDateRangeFilter('createdAt', false);

    return this.filterAddPrefix({
      intervalLength: appConfig.dateIntervalLength,
      ...(this.filter.partnerAccountIdTo ? { partnerAccountIdsTo: this.filter.partnerAccountIdTo } : {}),
      ...(this.filter.partnerAccountIdFrom ? { partnerAccountIdsFrom: this.filter.partnerAccountIdFrom } : {}),
      ...(this.filter.endpointCredentialFrom ? { endpointCredentialFrom: this.filter.endpointCredentialFrom } : {}),
      ...(this.filter.endpointCredentialTo ? { endpointCredentialTo: this.filter.endpointCredentialTo } : {}),
      ...(this.filter.userId ? { userId: this.filter.userId } : {}),
      ...(this.filter.phoneNumber ? { phoneNumber: this.filter.phoneNumber } : {}),
      ...(this.filter.promoCodeId ? { promoCodeId: this.filter.promoCodeId } : {}),
      ...(this.filter.status ? { status: this.filter.status } : {}),
      ...(createdAtStart && createdAtEnd
        ? {
            date: this.getDateFilterDiapasonFormat(
              prepareFilterDate(createdAtStart, { toISO: true }),
              prepareFilterDate(createdAtEnd, { toISO: true })
            )
          }
        : {}),
      ...filter
    }, appConfig.filterPrefix)
  }

  initFilter() {
    return {
      id: this.$route.query.id || null,
      externalId: this.$route.query.externalId || null,
      merchExternalId: this.$route.query.merchExternalId || null,
      externalSubId: this.$route.query.externalSubId || null,
      pspExternalId: this.$route.query.pspExternalId || null,
      status: this.$route.query.status || null,
      partnerAccountIdTo: this.$route.query.partnerAccountIdTo || null,
      partnerAccountIdFrom: this.$route.query.partnerAccountIdFrom || null,
      endpointCredentialFrom: this.$route.query.endpointCredentialFrom || null,
      endpointCredentialTo: this.$route.query.endpointCredentialTo || null,
      userId: this.$route.query.userId || null,
      phoneNumber: this.$route.query.phoneNumber || null,
      promoCodeId: this.$route.query.promoCodeId || null,
      amount: this.$route.query.amount || null,
    };
  }

  get statusOptions() {
    return [
      { text: this.$t('pspDepositOrders.statusAll'), value: null },
      ...getPspDepositOrderStatusList()
    ];
  }

  get getStatusFunc() {
    return getPspDepositOrderStatus;
  }

  openChart(attrName: string, group = false) {
    const dateFrom = DateTime.fromFormat(this.getDateRangeFilter('createdAt'), DATEPICKER_FORMAT).toFormat(DATE_FILTER_FORMAT);
    const dateTo = DateTime.fromFormat(this.getDateRangeFilter('createdAt', false), DATEPICKER_FORMAT).toFormat(DATE_FILTER_FORMAT);

    this.$modal.show(StatusSummaryChartModal, {
      ...(!group ? { data: this.pdoStatusSummary?.intervals || [] } : {}),
      ...(group ? { dataGroup: this.pdoStatusSummaryGroup?.intervals || [] } : {}),
      attrName,
      getStatusFunc: this.getStatusFunc,
      dataCallback: group ? this.setPdoStatusSummaryGroupRequest : this.setPdoStatusSummaryRequest,
      pageTitle: group ? `${this.$t(title)} ${(this.$t('common.group') as string).toLowerCase()}` : this.$t(title),
      subTitle: `${dateFrom} - ${dateTo}`,
    }, MODAL_CONFIG);
  }

  openChartByType(
    attrName: string,
    type: 'status' | 'endpoint' | 'partner'
  ) {
    const dateFrom = DateTime.fromFormat(this.getDateRangeFilter('createdAt'), DATEPICKER_FORMAT).toFormat(DATE_FILTER_FORMAT);
    const dateTo = DateTime.fromFormat(this.getDateRangeFilter('createdAt', false), DATEPICKER_FORMAT).toFormat(DATE_FILTER_FORMAT);
    let data: any[];
    let callback: any;
    let byNameAttr: string;

    switch (type) {
      case 'status':
        data = this.pdoStatusSummary?.intervals || [];
        callback = this.setPdoStatusSummaryRequest;
        byNameAttr = 'byStatuses';
        break;
      case 'endpoint':
        data = this.pdoEndpointSummary?.intervals || [];
        callback = this.getPdoEndpointSummaryRequest;
        byNameAttr = 'byEndpoints';
        break;
      case 'partner':
        data = this.pdoPartnerSummary?.intervals || [];
        callback = this.getPdoPartnerSummaryRequest;
        byNameAttr = 'byPartners';
        break;
      default:
        data = [];
        byNameAttr = '';
    }

    this.$modal.show(SummaryChartModal, {
      data,
      attrName,
      dataCallback: callback,
      pageTitle: this.$t(title),
      subTitle: `${dateFrom} - ${dateTo}`,
      valueName: type,
      byNameAttr,
    }, MODAL_CONFIG);
  }

  chartData(type: 'status' | 'endpoint' | 'partner') {
    switch (type) {
      case 'status': return this.pdoStatusSummary?.totalByStatuses || [];
      case 'endpoint': return this.pdoEndpointSummary?.totalByEndpoints || [];
      case 'partner': return this.pdoPartnerSummary?.totalByPartners || [];
      default: return [];
    }
  }

  get chartDataGroup() {
    return this.pdoStatusSummaryGroup?.totalByAmountGroups || [];
  }
}
